import {NgModule} from '@angular/core';

import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {SharedModule} from "@shared/shared.module";
import { ActesFactureComponent } from './actes-facture.component';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SharedModule,
    ],
  exports: [ActesFactureComponent],
  declarations: [ActesFactureComponent],
  providers: [],
})
export class ActesFactureModule {
}
